export const Slip_TXT = []
Slip_TXT["en"] = "Payment Slip"
Slip_TXT["th"] = "สลิปจ่ายเงิน"

export const Summary_Slip_TXT = []
Summary_Slip_TXT["en"] = "Total Amount And Processing Fee"
Summary_Slip_TXT["th"] = "ยอดรวมและค่าดำเนินการ"

export const Unit_TXT = []
Unit_TXT["en"] = "Unit"
Unit_TXT["th"] = "ยูนิต"

export const Rental_Unit_TXT = []
Rental_Unit_TXT["en"] = "Property No."
Rental_Unit_TXT["th"] = "เลขที่ทรัพย์"

export const PayName_TXT = []
PayName_TXT["en"] = "Payer's Name"
PayName_TXT["th"] = "ชื่อผู้ชำระเงิน"

export const Total_TXT = []
Total_TXT["en"] = "Total"
Total_TXT["th"] = "รวมทั้งหมด"

export const Specify_Amount_TXT = []
Specify_Amount_TXT["en"] = "Specify The Amount"
Specify_Amount_TXT["th"] = "ระบุจำนวนเงิน"

export const Please_Specify_Amount_TXT = []
Please_Specify_Amount_TXT["en"] = "Please specify the amount"
Please_Specify_Amount_TXT["th"] = "โปรดระบุจำนวนเงิน"

export const Full_Amount_TXT = []
Full_Amount_TXT["en"] = "Full Amount"
Full_Amount_TXT["th"] = "เต็มจำนวน"

export const Minimum_Amount_TXT = []
Minimum_Amount_TXT["en"] = "Minimum Amount"
Minimum_Amount_TXT["th"] = "ขั้นตํ่า"

export const Amount_Net_TXT = []
Amount_Net_TXT["en"] = "Net Amount"
Amount_Net_TXT["th"] = "ยอดชำระเงิน"

export const Fee_Amount_TXT = []
Fee_Amount_TXT["en"] = "Fee Amount"
Fee_Amount_TXT["th"] = "ค่าดำเนินการ"